import { render } from "./user-badge.global.vue?vue&type=template&id=255a567a"
import script from "./user-badge.global.vue?vue&type=script&lang=js"
export * from "./user-badge.global.vue?vue&type=script&lang=js"

import "./user-badge.global.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script